var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarTurn = function SvgCalendarTurn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#777776"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.6635 2.5h-13.3333c-1.67012 0-1.66321 1.66799-1.66321 1.66799v13.33331c0 1.6654 1.66321 1.6654 1.66321 1.6654h13.3333s1.6702.0013 1.6702-1.6654v-.837s-.0733-.6633-.8339-.6662c-.7607-.0028-.8339.6662-.8339.6662 0 .8333-.8334.8333-.8334.8333h-11.66663s-.83333 0-.83333-.8333v-11.66665c0-.831.83333-.83334.83333-.83334h11.66663s.8334 0 .8334.83334v6.00235h1.6678v-6.83201s-.0035-1.66799-1.6702-1.66799z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.4992 1.66683c0-.46024.3731-.833334.8333-.833334.4603 0 .8334.373094.8334.833334v3.33333c0 .46024-.3731.83334-.8334.83334-.4602 0-.8333-.3731-.8333-.83334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.83252 1.66683c0-.46024.3731-.833334.83333-.833334.46024 0 .83334.373094.83334.833334v3.33333c0 .46024-.3731.83334-.83334.83334-.46023 0-.83333-.3731-.83333-.83334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5013 9.1652c-.46024 0-.83333-.3731-.83333-.83333 0-.46024.37309-.83334.83333-.83334h15c.4602 0 .8333.3731.8333.83334 0 .46023-.3731.83333-.8333.83333z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17.4997 5.8335c-.4603 0-.8334.37309-.8334.83333v4.99997c0 .8334-.8333.8334-.8333.8334h-5.7248l.6556-.4902c.344-.3058.375-.8325.0692-1.1765s-.8325-.375-1.17647-.0692l-2.29383 1.9464c-.1779.1581-.27969.3848-.27969.6228s.10179.4647.27969.6228l2.29383 1.9464c.34397.3058.87067.2748 1.17647-.0692s.2748-.8707-.0692-1.1765l-.6556-.4902h6.5581c.8334 0 1.6667-.8333 1.6667-1.6666v-5.83337c0-.46024-.3731-.83333-.8333-.83333z",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarTurn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_turn.54e52add.svg";
export { ForwardRef as ReactComponent };